import React, { useState, useEffect } from 'react';

const ServerForm = ({
  onSubmit,
  editingServer,
  cancelEdit,
  setModal,
}: {
  onSubmit: any;
  editingServer: any;
  cancelEdit: any;
  setModal?: any;
}) => {
  const [form, setForm] = useState({
    host: '',
    port: '',
    calledAET: '',
    callingAET: '',
    isDefault: false,
  });

  useEffect(() => {
    if (editingServer) {
      setForm(editingServer);
    }
  }, [editingServer]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const formData = {
      ...form,
      callingAET: form.callingAET || 'MAYU',
    };
    onSubmit(formData);
    setForm({
      host: '',
      port: '',
      calledAET: '',
      callingAET: '',
      isDefault: false,
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <form
        onSubmit={handleSubmit}
        className="space-b-4 bg-secondary-dark mx-auto max-w-md rounded-lg p-6 shadow-lg sm:w-full"
      >
        <div className="flex justify-end">
          <button
            type="button"
            onClick={() => setModal(false)} // Cierra el modal
            className="rounded-md px-6 py-3 font-semibold text-white hover:text-red-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="currentColor"
              className="bi bi-x-circle"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </button>
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="host"
            className="mb-2 text-sm text-white"
          >
            Host
          </label>
          <input
            id="host"
            name="host"
            placeholder="Host"
            value={form.host}
            onChange={handleChange}
            required
            className="rounded-md border border-gray-600 bg-black p-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex flex-col">
          <label
            htmlFor="port"
            className="mb-2 text-sm text-white"
          >
            Port
          </label>
          <input
            id="port"
            name="port"
            placeholder="Port"
            value={form.port}
            onChange={handleChange}
            required
            type="number"
            className="rounded-md border border-gray-600 bg-black p-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex flex-col">
          <label
            htmlFor="calledAET"
            className="mb-2 text-sm text-white"
          >
            Called AET
          </label>
          <input
            id="calledAET"
            name="calledAET"
            placeholder="Called AET"
            value={form.calledAET}
            onChange={handleChange}
            required
            className="rounded-md border border-gray-600 bg-black p-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex flex-col">
          <label
            htmlFor="callingAET"
            className="mb-2 text-sm text-white"
          >
            Calling AET (Opcional)
          </label>
          <input
            id="callingAET"
            name="callingAET"
            placeholder="Calling AET"
            value={form.callingAET}
            onChange={handleChange}
            className="rounded-md border border-gray-600 bg-black p-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="my-2 flex items-center space-x-2">
          <input
            type="checkbox"
            name="isDefault"
            checked={form.isDefault}
            onChange={handleChange}
            className="h-5 w-5 rounded border-gray-600 text-blue-500 focus:ring-2 focus:ring-blue-500"
          />
          <label
            htmlFor="isDefault"
            className="text-sm text-white"
          >
            ¿Servidor por defecto?
          </label>
        </div>

        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="rounded-md bg-blue-600 px-6 py-3 font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {editingServer ? 'Actualizar' : 'Agregar'}
          </button>
          {editingServer && (
            <button
              className="rounded-md bg-red-600 px-6 py-3 font-semibold text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
              type="button"
              onClick={cancelEdit}
            >
              Cancelar
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default ServerForm;
